module.exports = __webpack_public_path__ + "img/jamesway_egg_icon.498e5f5b.png";